import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{discourse-tag this.rowValue count=this.item.count noHref=true}}
*/
{
  "id": "NpZuS6OS",
  "block": "[[[1,[28,[35,0],[[30,0,[\"rowValue\"]]],[[\"count\",\"noHref\"],[[30,0,[\"item\",\"count\"]],true]]]]],[],false,[\"discourse-tag\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/tag-chooser-row.hbs",
  "isStrictMode": false
});